module.exports = __webpack_public_path__ + "img/symbol_0.244cf8d2.png";